// Please do not use optional chaining (?.), nullish coalescing (??), or other ES2020+ features

import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Circle } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import ComponentWrapper from '../../../common/ComponentWrapper';

const EventsContainer = styled(Box)({
  width: '100%',
  height: '100%',
  zIndex: 1000,
  backgroundColor: '#1E1E1E',
  color: '#ffffff',
  fontSize: '13px',
  padding: '16px',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '4px',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.3)',
    },
  },
});

const EventItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
  '& .MuiSvgIcon-root': {
    color: '#ffffff',
    marginRight: '8px',
    fontSize: '5px',
  },
});

const Events = ({ events }) => {
  return (
    <EventsContainer>
      {events.map(function(event, index) {
        return (
          <EventItem key={index}>
            {event.enabled === false ? (
              <DoneIcon style={{ color: '#00e676', marginRight: 8, fontSize: 16 }} />
            ) : (
              <Circle style = {{ marginLeft: 8 }} />
            )}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '8px' }}>{event.title}</span>
              {event.next_fire_time ? <span style={{ color: '#6E6BE6' }}>`next_fire_time: {event.next_fire_time}`</span> : null}
            </div>
          </EventItem>
        );
      })}
    </EventsContainer>
  );
};

export default class EventsWrapper extends ComponentWrapper {
  state = {
    events: [],
  };

  componentDidMount() {
    this.getEvents();
  };

  getEvents = () => {
    this.get({
      url: `/meta_query?meta_query=["events"]`,
      cb: ({ _meta_query }) => {
        const allEvents = _meta_query.events;

        if (allEvents && allEvents.FIXED_TIME_SCHEDULER) {
          var fixedTimeSchedulerEvents = allEvents.FIXED_TIME_SCHEDULER.slice().reverse();
          this.setState({ events: fixedTimeSchedulerEvents });
        }
      }
    });
  }

  useImperativeHandle = () => {
    return {
      updateEvents: getEvents
    };
  };

  render() {
    return <Events events={this.state.events} />;
  };
};
